<script>
export default {
  name: "theme-dark-svg"
}
</script>

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3299_52371)">
      <path opacity="0.4" d="M9.375 3.125C9.375 3.27344 9.47266 3.40234 9.61719 3.44531L11.125 3.875L11.5547 5.38281C11.5937 5.52344 11.7266 5.625 11.875 5.625C12.0234 5.625 12.1523 5.52734 12.1953 5.38281L12.625 3.875L14.1328 3.44531C14.2734 3.40625 14.375 3.27344 14.375 3.125C14.375 2.97656 14.2773 2.84766 14.1328 2.80469L12.625 2.375L12.1953 0.867188C12.1563 0.726563 12.0234 0.625 11.875 0.625C11.7266 0.625 11.5977 0.722656 11.5547 0.867188L11.125 2.375L9.61719 2.80469C9.47656 2.84375 9.375 2.97656 9.375 3.125ZM12.5 8.75C12.5 8.97266 12.6484 9.16797 12.8594 9.22656L15.125 9.875L15.7734 12.1406C15.8359 12.3555 16.0312 12.5 16.25 12.5C16.4688 12.5 16.668 12.3516 16.7266 12.1406L17.375 9.875L19.6406 9.22656C19.8555 9.16406 20 8.96875 20 8.75C20 8.53125 19.8516 8.33203 19.6406 8.27344L17.375 7.625L16.7266 5.35938C16.6641 5.14453 16.4688 5 16.25 5C16.0312 5 15.832 5.14844 15.7734 5.35938L15.125 7.625L12.8594 8.27344C12.6445 8.33594 12.5 8.53125 12.5 8.75Z" fill="#CED4DA"/>
      <path d="M7.49219 5C3.35156 5 0 8.36328 0 12.5078C0 16.6523 3.35156 20.0156 7.49219 20.0156C9.52344 20.0156 11.3633 19.207 12.7109 17.8906C12.9062 17.6992 12.957 17.4023 12.832 17.1602C12.707 16.918 12.4375 16.7812 12.168 16.8281C11.8516 16.8828 11.5234 16.9141 11.1875 16.9141C8.03516 16.9141 5.47656 14.3516 5.47656 11.1875C5.47656 9.04688 6.64844 7.17969 8.38281 6.19531C8.62109 6.05859 8.74219 5.78516 8.68359 5.51953C8.625 5.25391 8.39844 5.05469 8.125 5.03125C7.91406 5.01172 7.70312 5.00391 7.48828 5.00391L7.49219 5Z" fill="#CED4DA"/>
    </g>
    <defs>
      <clipPath id="clip0_3299_52371">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<style scoped>

</style>
